import { actionsPreprocessor } from '../../utils/redux';

const actionNames = ['SAVE_COORDINATES', 'SAVE_ZOOM'];

const { actions, actionTypes } = actionsPreprocessor('gmaps', actionNames);

export default actions;
export { actionTypes };
